// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
// import {annotation as d3_annotation} from 'd3-svg-annotation'
import * as susie from 'd3-svg-annotation'
import * as AnnotationTypes from 'd3-svg-annotation'
import IconNoteInfo from '../styles/icons/icon-note-info.svg'
import IconNoteWarning from '../styles/icons/icon-note-warning.svg'
import IconNoteSuccess from '../styles/icons/icon-note-success.svg'
import { isDarkMode } from '../utils/configUtils'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'
import { SKIN_BACKGROUND, SKIN_BACKGROUND_DARK } from '../utils/colorUtils'
// import {dentedRect} from '../utils/pathUtils'
export const ANNOTATION_TYPES = [
  'annotationCallout',
  'annotationCalloutCircle',
  'annotationCalloutCurve',
  'annotationCalloutElbow',
  'annotationCalloutRect',
  'annotationXThreshold',
  'annotationYThreshold',
  'annotationXYThreshold',
] //,'annotationLabel','annotationBadge'

export const ANNOTATION_MODES = [
  {
    id: 'base',
    colors: {
      light: {
        color: '#222222',
        fill: '#9BC3D3',
      },
      dark: {
        color: '#FFFFFF',
        fill: '#9BC3D3',
      },
    },
  },
  {
    id: 'info',
    colors: {
      light: {
        color: '#222222',
        fill: '#9BC3D3',
        icon: {
          svg: IconNoteInfo,
          fill: '#1E6C8D',
        },
      },
      dark: {
        color: '#FFFFFF',
        fill: '#9BC3D3',
        icon: {
          svg: IconNoteInfo,
          fill: '#FFFFFF',
        },
      },
    },
  },
  {
    id: 'warning',
    colors: {
      light: {
        color: '#222222',
        fill: '#EEDA71',
        icon: {
          svg: IconNoteWarning,
          fill: '#7A5815',
        },
      },
      dark: {
        color: '#FFFFFF',
        fill: '#FFD684',
        icon: {
          svg: IconNoteWarning,
          fill: '#FFFFFF',
        },
      },
    },
  },
  {
    id: 'success',
    colors: {
      light: {
        color: '#222222',
        fill: '#127434',
        icon: {
          svg: IconNoteSuccess,
          fill: '#127434',
        },
      },
      dark: {
        color: '#FFFFFF',
        fill: '#127434',
        icon: {
          svg: IconNoteSuccess,
          fill: '#FFFFFF',
        },
      },
    },
  },
  {
    id: 'alert',
    colors: {
      light: {
        color: '#222222',
        fill: '#990000',
        icon: {
          svg: IconNoteWarning,
          fill: '#990000',
        },
      },
      dark: {
        color: '#FFFFFF',
        fill: '#FF6161',
        icon: {
          svg: IconNoteWarning,
          fill: '#FFFFFF',
        },
      },
    },
  },
]

const d3_annotation = susie.annotation
let toSusieConfig = (a, viz) => {
  const isChartHorizontal = viz.chart.config.horizontal
  const axis = {
    x: isChartHorizontal ? 'y' : 'x',
    y: isChartHorizontal ? 'x' : 'y',
  }
  let charts = d3_select(viz.$chartContainer).selectAll('.chart-wrapper').select('svg')
  let globalOffset = viz.$chartContainer.getBoundingClientRect()
  let origins = charts
    .nodes()
    .map($el => $el.getScreenCTM())
    .map(m => {
      return {
        x: m.e - globalOffset.left,
        y: m.f - globalOffset.top,
      }
    })
  let currentSize = viz.chart.contentSize || viz.chart.size || { width: 0, height: 0 }
  let annotationConfig = { ...a.config }
  annotationConfig = JSON.parse(JSON.stringify(annotationConfig))

  if (!annotationConfig.note.title) annotationConfig.note.title = 'Annotation title'
  if (a.type === 'annotationXThreshold' || a.type === 'annotationYThreshold')
    annotationConfig.type = AnnotationTypes['annotationXYThreshold']
  else annotationConfig.type = AnnotationTypes[a.type]
  const annotationMode = !a.options?.mode
    ? ANNOTATION_MODES[0]
    : ANNOTATION_MODES.find(am => am.id === a.options.mode)

  annotationConfig.id = a.id
  annotationConfig.color = !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions)
    ? '#222'
    : '#ddd'
  annotationConfig.note.color =
    annotationMode.colors[
      isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? 'dark' : 'light'
    ].color
  annotationConfig.note.bgColor =
    annotationMode.colors[
      isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? 'dark' : 'light'
    ].fill
  annotationConfig.note.icon =
    annotationMode.colors[
      isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? 'dark' : 'light'
    ].icon
  annotationConfig.note.bgOpacity = a.options?.bgOpacity
  annotationConfig.note.bgPadding = {
    top: 14,
    left: annotationConfig.note.icon ? 44 : 14,
    right: 14,
    bottom: 14,
  }
  annotationConfig.note.hideConnector = false

  if (a.type === 'annotationXThreshold') {
    annotationConfig.subject = { y1: 0, y2: currentSize.height }
    annotationConfig.note.lineType = 'vertical'
    annotationConfig.note.hideConnector = a.options?.hideConnector
  } else if (a.type === 'annotationYThreshold') {
    annotationConfig.subject = { x1: 0, x2: currentSize.width }
    annotationConfig.note.lineType = 'horizontal'
    annotationConfig.note.hideConnector = a.options?.hideConnector
  } else if (a.type === 'annotationXYThreshold') {
    annotationConfig.note.hideConnector = a.options?.hideConnector
    annotationConfig.note.align = 'middle'
    //annotationConfig.note.orientation = 'leftRight'
    annotationConfig.note.lineType = isChartHorizontal ? 'vertical' : 'horizontal'
    //if (viz.chart?.axes?.x) {
    if (viz.chart.axes?.x?.func?.scale && a.domainX1 && a.domainX2) {
      annotationConfig.subject = {
        [`${axis.x}1`]: viz.chart.axes.x.func.scale()(a.domainX1),
        [`${axis.x}2`]:
          viz.chart.axes.x.func.scale()(a.domainX2) +
          (viz.chart.axes.x.scale.bandwidth ? viz.chart.axes.x.scale.bandwidth() : 0),
      }
      annotationConfig.note.wrap = isChartHorizontal
        ? undefined
        : annotationConfig.subject.x2 - annotationConfig.subject.x1
    }
  }
  if (!annotationConfig.x) {
    annotationConfig.x = 0.5
    annotationConfig.y = 0.6
    annotationConfig.dx = a.type === 'annotationXYThreshold' ? 0 : 0.2
    annotationConfig.dy = a.type === 'annotationXYThreshold' ? -0.05 : -0.1
  }

  let offset = origins[annotationConfig.chartIndex]

  //IF first time set center by subject on annotationXYThreshold
  if (
    annotationConfig.subject &&
    (annotationConfig[axis.x] === 0.5 || annotationConfig[axis.x] === 0.6) &&
    a.type === 'annotationXYThreshold'
  )
    annotationConfig[axis.x] =
      annotationConfig[axis.x] *
        (annotationConfig.subject[`${axis.x}1`] + annotationConfig.subject[`${axis.x}2`]) +
      (offset?.[axis.x] || 0)
  else annotationConfig.x = annotationConfig.x * currentSize.width + (offset?.x || 0)
  annotationConfig.y = annotationConfig.y * currentSize.height + (offset?.y || 0)
  annotationConfig.dx = annotationConfig.dx * currentSize.width
  annotationConfig.dy = annotationConfig.dy * currentSize.height

  //Manage X limits
  if (a.type === 'annotationXYThreshold') {
    if (
      annotationConfig.subject &&
      (annotationConfig[axis.x] < annotationConfig.subject[`${axis.x}1`] ||
        annotationConfig[axis.x] > annotationConfig.subject[`${axis.x}2`])
    ) {
      annotationConfig[axis.x] =
        (annotationConfig.subject[`${axis.x}1`] + annotationConfig.subject[`${axis.x}2`]) / 2
    }
  }

  if (annotationConfig.subject) {
    if (annotationConfig.subject.height)
      annotationConfig.subject.height = annotationConfig.subject.height * currentSize.height
    if (annotationConfig.subject.width)
      annotationConfig.subject.width = annotationConfig.subject.width * currentSize.width
    if (annotationConfig.subject.radius)
      annotationConfig.subject.radius = annotationConfig.subject.radius * currentSize.width
  }
  return annotationConfig
}
let fromSusieConfig = (src, d, viz) => {
  let currentSize = viz.chart.contentSize || viz.chart.size
  let charts = d3_select(viz.$chartContainer).selectAll('.chart-wrapper').select('svg')
  let globalOffset = viz.$chartContainer.getBoundingClientRect()
  let origins = charts
    .nodes()
    .map($el => $el.getScreenCTM())
    .map(m => {
      return {
        x: m.e - globalOffset.left,
        y: m.f - globalOffset.top,
      }
    })
  let propper = { ...src, config: { ...d.json } }
  delete propper.config.type
  //propper = JSON.parse(JSON.stringify(propper))

  // propper.config.chartIndex = origins.findLastIndex((o)=>o.x<propper.config.x && o.y<propper.config.y)
  let dist = (a, b) => Math.sqrt((b.x - a.x) * (b.x - a.x) + (b.y - a.y) * (b.y - a.y))
  let dists = origins
    .map(o => ({ x: o.x + currentSize.width / 2, y: o.y + currentSize.height / 2 }))
    .map(c => dist(c, propper.config))
  propper.config.chartIndex = dists.indexOf(Math.min(...dists))
  propper.config.x = propper.config.x - origins[propper.config.chartIndex].x
  propper.config.y = propper.config.y - origins[propper.config.chartIndex].y

  propper.config.x = propper.config.x / currentSize.width
  propper.config.y = propper.config.y / currentSize.height
  propper.config.dx = propper.config.dx / currentSize.width
  propper.config.dy = propper.config.dy / currentSize.height
  if (propper.config.subject) {
    if (propper.config.subject.height)
      propper.config.subject.height = propper.config.subject.height / currentSize.height
    if (propper.config.subject.width)
      propper.config.subject.width = propper.config.subject.width / currentSize.width
    if (propper.config.subject.radius)
      propper.config.subject.radius = propper.config.subject.radius / currentSize.width
  }
  return propper
}

function AnnotationBehavior($root, viz, config = {}) {
  // d3_select(viz.$annotationsContainer.parentElement).raise().style('max-width',viz.$chartContainer.scrollWidth+'px').style('max-height',viz.$chartContainer.scrollHeight+'px')
  d3_select(viz.$annotationsContainer)
    .style('width', viz.$chartContainer.scrollWidth)
    .style('height', viz.$chartContainer.scrollHeight)
    //chapuzilla para esconder scrolls on resize
    .style('display', 'block')

  let downTarget = null

  let editMode = viz.editMode && $root.closest('.editing-annotations')

  let triggerChange = function (src, d) {
    let propper = fromSusieConfig(src, d, viz)
    if (viz.onAnnotationChange) viz.onAnnotationChange(propper)
  }

  let d3Configs = (config.annotations || []).map(a => {
    return toSusieConfig(a, viz)
  })

  const makeAnnotations = d3_annotation()
    .editMode(editMode)
    .notePadding(15)
    .textWrap(218)
    .annotations(d3Configs)
    .on('dragend', d => {
      // console.log("ANNOTATION DRAGGED")
      let src = config.annotations.find(a => a.id === d.id)
      // Menuda basura... Es para poder comprovar si se ha movido...
      let srcConfig = toSusieConfig(src, viz)

      if (
        d.dx === srcConfig.dx &&
        d.dy === srcConfig.dy &&
        d.x === srcConfig.x &&
        d.y === srcConfig.y
      ) {
        // console.log("THIS WAS A CLICK")
        if (downTarget) {
          setEditing(d, downTarget, () => triggerChange(src, d))
          downTarget = null
        }
      } else {
        triggerChange(src, d)
      }
    })

  let annotationsRoot = d3_select($root)
    .selectAll('.annotation-group')
    .data(config.annotations ? [null] : [])
  let annotationsRootEnter = annotationsRoot
    .enter()
    .append('g')
    .attr('class', 'annotation-group')
    .style('pointer-events', 'all')
  annotationsRoot = annotationsRoot.merge(annotationsRootEnter)

  if (viz.chart.margin)
    annotationsRoot.attr('transform', `translate(${viz.chart.margin.left},${viz.chart.margin.top})`)

  annotationsRoot
    .call(makeAnnotations)
    .raise()
    .style('font-family', 'santander-microtext-embedded')
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.annotation-note-content')
    .selectAll('text')
    .style('cursor', editMode ? 'text' : 'default')
    .style('fill', d => d.note.color)
    .on('mousedown', e => {
      downTarget = e.currentTarget
    })
  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .on('click', function () {
      d3_select(this).raise()
      if (viz.onAnnotationClick) viz.onAnnotationClick()
    })
  makeAnnotations.editMode(editMode).update()

  const annotationNoteContent = annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.annotation-note-content')

  const annotationNoteBg = annotationNoteContent.select('.annotation-note-bg')

  annotationNoteBg
    .style(
      'outline',
      `0.5px solid ${
        !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? '#CCCCCC' : '#FFFFFF'
      }`
    )
    .style('border-radius', '0px 2px 2px 0px')
    .style('fill-opacity', d => (d.note.bgOpacity !== undefined ? d.note.bgOpacity / 10 : 0.8))
    .style('fill', d => {
      return !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions)
        ? SKIN_BACKGROUND
        : SKIN_BACKGROUND_DARK
    })

  //Background line
  let annotationBgLine = annotationNoteContent
    .selectAll('.annotation-note-bg-line')
    .data(d => (d.note.bgColor ? [d.note] : []))

  const annotationBgLineEnter = annotationBgLine
    .enter()
    .append('line')
    .attr('class', 'annotation-note-bg-line')
    .attr('stroke-width', '3')
  annotationBgLine.exit().remove()
  annotationBgLine = annotationBgLine.merge(annotationBgLineEnter)
  annotationBgLine
    .attr('x1', d => -d.bgPadding.left - 1.5)
    .attr('x2', d => -d.bgPadding.left - 1.5)
    .attr('y1', d => -d.bgPadding?.top)
    .attr('stroke', d => d.bgColor)

  let annotationIcon = annotationNoteContent
    .selectAll('.annotation-note-icon')
    .data(d => (d.note.icon ? [d.note.icon] : []))

  const annotationIconEnter = annotationIcon
    .enter()
    .append('g')
    .attr('class', 'annotation-note-icon')
    .style('transform', 'translate(-35px, -4px)')
  annotationIcon.exit().remove()
  annotationIcon = annotationIcon.merge(annotationIconEnter)
  annotationIcon.html(d => d.svg)

  annotationIcon
    .select('svg')
    .attr('height', 24)
    .attr('width', 24)
    .attr('fill', d => d.fill)

  const connector = annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-connector')
  const noteLine = annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.note-line')

  connector.style('display', d => (d.note.hideConnector ? 'none' : 'initial'))
  noteLine.style('display', d => (d.note.hideConnector ? 'none' : 'initial'))

  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .nodes()
    .forEach(el => {
      el.querySelectorAll('.handle').forEach(handle => {
        handle.style.fillOpacity = '0.3'
        handle.style.fill = !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions)
          ? '#eee'
          : '#888'
        //handle.style.stroke = !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? '#888' : '#ccc'
        handle.style.strokeDasharray = '2'
      })
    })
  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.annotation-note-content')
    .each(function (d) {
      let sel = d3_select(this)
      if (!sel.select('.number').node()) {
        let number = sel.append('g').attr('class', 'number handle')
        number.append('circle').attr('r', 10)

        number
          .append('text')
          .text(d.id)
          .attr('font-size', '10')
          .attr('text-anchor', 'middle')
          .attr('dominant-baseline', 'central')
          .style('pointer-events', 'none')
      }
      // not this way...
      // d3_select(sel.node().parentNode).select('.note-line').attr('d','M0,0H100,0')
      let bbox = sel.select('.annotation-note-bg').node().getBBox()

      sel
        .select('.number')
        .attr('transform', `translate(${bbox.width / 2 - 10},${bbox.height - 15})`)
        .raise()
        .style('fill-opacity', '1')
        .style('display', editMode ? 'block' : 'none')

      sel
        .select('.number')
        .select('circle')
        .attr(
          'fill',
          !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? '#fafafa' : '#FFF'
        )
        .attr(
          'stroke',
          !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? '#ccc' : '#444'
        )
        .attr('stroke-dasharray', 'none')

      sel
        .select('.number')
        .select('text')
        .style(
          'fill',
          !isDarkMode(viz.config, viz._parent.viz.accessibilityOptions) ? '#020202' : '#020202'
        )
      // if(!sel.select('.text-rect-title').node()){
      //   sel.append('path').attr('class','text-rect-title').attr('fill','#fafafa').attr('stroke','#aaa')
      //   sel.append('path').attr('class','text-rect-sub').attr('fill','#fafafa').attr('stroke','#aaa')
      // }
      // let tbx = sel.select('.annotation-note-title').node().getBBox()
      // let sbx = sel.select('.annotation-note-label').node().getBBox()
      // let width = Math.max(tbx.width,sbx.width)
      // sel.select('.text-rect-title').attr('d',dentedRect(width,tbx.height,['tl','tr','bl','br'],null,5)).lower()
      // sel.select('.text-rect-sub').attr('d',dentedRect(width,sbx.height,['tl','tr','bl','br'],null,5)).attr('transform',`translate(0,${sbx.y})`).lower()

      //Set annotation note line height
      sel.select('.annotation-note-bg-line').attr('y2', bbox.height - d.note.bgPadding?.top)
    })
  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.note-line')
    .lower()
  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-connector')
    .raise()
  // annotationsRoot.select('.annotations')
  //   .selectAll('.annotation').select('.annotation-note').select('.annotation-note-bg').lower()
  annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-note')
    .select('.annotation-note-content')
    .select('.number')
    .raise()

  //ICONS
  const annotationsSubject = annotationsRoot
    .select('.annotations')
    .selectAll('.annotation')
    .select('.annotation-subject')

  const getAnnotationIcon = id => {
    const annotation = config.annotations.find(annotation => annotation.id === id)
    switch (annotation.type) {
      case 'annotationCallout':
      case 'annotationCalloutElbow':
      case 'annotationCalloutCurve':
        return annotation?.icon
      default:
        return null
    }
  }

  const ICON_HEIGHT = 23
  const ICON_WIDTH = 23

  const getIconTranslate = d => {
    let x = 0
    let y = -2
    if (Math.trunc(d.dx) > 0) x = ICON_WIDTH * -1
    else if (Math.trunc(d.dx) < 0) x = 0
    else if (Math.trunc(d.dx) === 0) {
      x = -ICON_WIDTH / 2
      if (Math.trunc(d.dy) > 0) y = -ICON_HEIGHT
      else if (Math.trunc(d.dy) < 0) y = 0
    }

    if (Math.trunc(d.dy) > 0) y = -ICON_HEIGHT

    return `translate(${x}, ${y})`
  }

  let iconGroup = annotationsSubject.selectAll('.icon').data(
    d => {
      const icon = getAnnotationIcon(d.id)
      return !!icon ? [{ id: d.id, ...icon, parentData: d }] : []
    },
    dd => dd.id
  )
  iconGroup.exit().remove()
  let iconGroupEnter = iconGroup.enter().append('g').attr('class', 'icon')
  iconGroupEnter.attr('transform', d => getIconTranslate(d.parentData))
  //iconGroupEnter.style('opacity', 0).transition().duration(500).style('opacity', 1)
  iconGroup = iconGroup.merge(iconGroupEnter)

  iconGroup.transition(400).attr('transform', d => getIconTranslate(d.parentData))
  iconGroup.html(d => (d.icon ? d.icon.svg : null))
  let iconGroupSvg = iconGroup.select('svg')
  //Hay q hardcodear nuevos ids en los defs y en los use para hacer unicas las modificaciones
  iconGroupSvg
    .select('defs')
    .select('path')
    .attr('id', function (d) {
      return this.getAttribute('id') ? this.getAttribute('id') + `annotation-icon-${d.id}` : null
    })
  iconGroupSvg.select('use').attr('xlink:href', function (d) {
    return this.getAttribute('xlink:href')
      ? this.getAttribute('xlink:href') + `annotation-icon-${d.id}`
      : null
  })
  iconGroupSvg.selectAll('path, polygon').attr('fill', function () {
    let d = d3_select(this.parentNode).datum()
    return d && d.color && !d.icon.disableColorModifier ? d.color : this.getAttribute('fill')
  })
  iconGroupSvg.attr('height', `${ICON_HEIGHT}px`).attr('width', `${ICON_WIDTH}px`)
  iconGroupSvg.select('use').attr('fill', function (d) {
    return d && d.color && !d.icon.disableColorModifier ? d.color : this.getAttribute('fill')
  })

  // apaño para la transicion del "play" de _ghostData
  if (viz.chart._ghostData)
    annotationsRoot = annotationsRoot.transition().duration(800).style('opacity', 0)
  annotationsRoot.transition().duration(1000).delay(1400).style('opacity', 1)

  function auto_grow(element, original) {
    element.style.height = '16px'
    element.style.height = element.scrollHeight + 'px'
    let parentAllowed = original.parentNode.getBBox().width - 20
    element.style.width = 16 + 'px'
    element.style.whiteSpace = 'nowrap'
    let fromMaxWidth = Math.min(140, element.scrollWidth)
    element.style.whiteSpace = 'normal'
    element.style.width = parentAllowed + 'px'
    element.style.width =
      Math.max(fromMaxWidth, Math.max(parentAllowed, element.scrollWidth)) + 'px'

    // element.style.height = "16px";
    // element.style.height = (element.scrollHeight)+"px";
    // let parentAllowed = original.parentNode.getBBox().width - 20
    // element.style.width = parentAllowed+'px'
    // element.style.width = (Math.max(parentAllowed,element.scrollWidth))+"px";
  }
  let setEditing = (d, node, callback) => {
    console.log('ENTRA SET EDITING')
    let type = node.className.baseVal.indexOf('annotation-note-title') >= 0 ? 'title' : 'label'
    let bb1 = node.getBBox()
    let globalOffset = viz.chart.margin
      ? { x: viz.chart.margin.left, y: viz.chart.margin.top }
      : { x: 0, y: 0 }
    let translate = node.parentNode
      .getAttribute('transform')
      .replace('translate', '')
      .replace('(', '')
      .replace(')', '')
      .split(',')
    // let localpoint = type==='title'?{x:d.x+d.dx,y:d.y+d.dy+15}:{x:d.x+d.dx,y:d.y+d.dy+15}
    // localpoint.x-=d.translation.x
    // localpoint.y-=d.translation.y
    let localpoint = d.translation
    localpoint.x += +translate[0] + bb1.x + globalOffset.x
    localpoint.y += +translate[1] + bb1.y + globalOffset.y
    var myforeign = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject')
    var textarea = document.createElement('textarea')
    var textnode = document.createTextNode(d.note[type])
    textarea.appendChild(textnode)
    textarea.setAttribute('contentEditable', 'true')
    // textarea.setAttribute("width", "140px");
    textarea.style.width = '140px'
    textarea.style.height = bb1.height + 'px'
    textarea.style.fontFamily = 'santander-microtext-embedded'
    textarea.style.lineHeight = '19px'
    textarea.style.fontSize = '16px'
    textarea.style.overflow = 'hidden'
    textarea.style.resize = 'none'
    textarea.style.minHeight = textarea.style.height
    // textarea.style.maxHeight="140px"
    textarea.style.border = 'solid 1px #CEDEE7'
    textarea.style.outline = 'none'
    textarea.style.padding = '4px'
    textarea.style.overflowWrap = 'normal'
    textarea.style.background = '#F6FAFC'
    textarea.style.borderRadius = '4px'

    myforeign.setAttribute('width', '800px')
    myforeign.setAttribute('height', '300px')
    // myforeign.classList.add("foreign"); //to make div fit text
    // textarea.classList.add("insideforeign"); //to make div fit text

    let unsetEditing = () => {
      let content = textarea.value
      d.note[type] = content
      myforeign.remove()
      callback()
    }
    textarea.addEventListener('input', e => {
      auto_grow(textarea, node)
    })
    textarea.addEventListener('keydown', e => {
      if (e.code === 'Enter') {
        e.preventDefault()
        textarea.blur()
      }
    })
    textarea.addEventListener('blur', unsetEditing)
    myforeign.setAttributeNS(
      null,
      'transform',
      'translate(' + localpoint.x + ' ' + localpoint.y + ')'
    )
    $root.appendChild(myforeign)
    myforeign.appendChild(textarea)

    auto_grow(textarea, node)

    textarea.focus()
    textarea.select()
  }
}

AnnotationBehavior.defaultConfig = {
  index: 203,
  /**
   * {-EN-} Array of annotation objects with a title and subtitle. See [annotation](#/developer/PropDetails#annotations)
   * {-ES-} Matriz de objetos de anotación con título y subtítulo. Ver [anotación](#/developer/PropDetails#annotations)
   */
  annotations: {
    type: [Array],
    default: [],
    exposed: true,
  },
}

AnnotationBehavior.configName = 'AnnotationBehavior'
export default AnnotationBehavior
